import {Component, OnInit, ViewChild, ElementRef, Renderer2, OnDestroy} from '@angular/core';
import {MatDialog, MatDialogConfig} from '@angular/material/dialog';
import {BetslipComponent} from '../betslip/betslip.component';
import {ActivatedRoute} from "@angular/router";
import {Subscription, switchMap} from "rxjs";
import {ExposureService} from "../services/exposure.service";
import {ToastrService} from "ngx-toastr";
import {DomSanitizer, SafeResourceUrl} from '@angular/platform-browser';
import {SocceroddsService} from "../services/soccer/soccerodds.service";
import {SoccerBetsService} from "../services/soccer/soccer-bets.service";
import {BetSlipService} from "../services/betslip.service";

@Component({
  selector: 'app-soccerdetails',
  templateUrl: './soccerdetails.component.html',
  styleUrls: ['./soccerdetails.component.css']
})
export class SoccerdetailsComponent implements OnInit, OnDestroy {
  data: any = {
    type: "back",
    value: 12
  };
  math = Math;
  event_id: any;
  event_name: any = '';
  videourl: any = "";
  scoreurl: any = "";
  show_tv:boolean = false;
  inplay :boolean = false;

 
  
  competition_name: any = '';
  event_time: any = '';
  market_id: any;
  market: any = [];
  markets: any = [];
  soccer_bets: any[] = [];
  myInterval: any
  selectedTabIndex = 0;
  private scoreSubscription: Subscription;
  private marketSubscription: Subscription;

  isMobile: boolean;

  constructor(public betSlipService: BetSlipService,public sanitizer: DomSanitizer, public dialog: MatDialog, private toastr: ToastrService, private renderer: Renderer2, private activatedRoute: ActivatedRoute, private soccerBetService:SoccerBetsService, private soccerOddService: SocceroddsService) {
  }

  ngOnInit(): void {
    this.checkIsMobile();
    window.addEventListener('resize', () => {
      this.checkIsMobile();
    });
    this.activatedRoute.params.subscribe((param: any) => {
      this.event_id = param['event_id'];
      this.getMarket();
      // this.videourl = this.sanitizer.bypassSecurityTrustResourceUrl("https://mis3.sqmr.xyz/rtv.php?eventId=" + this.event_id);
      this.videourl = this.sanitizer.bypassSecurityTrustResourceUrl("https://mis3.sqmr.xyz/rtv.php?eventId=" + this.event_id);
      this.scoreurl = this.sanitizer.bypassSecurityTrustResourceUrl("https://dpmatka.in/sr.php?eventid=" + this.event_id+"&sportid=1");
      //console.log(this.videourl);
    });
    this.myInterval = setInterval(() => {
      if (this.markets.length > 0) {
        this.getMarket();
      }
      this.getSoccerBets();
    }, 1000);

     this.soccerBetService.refreshSoccerBets.subscribe(() => {
      this.getSoccerBets();
    })

  }

   getSoccerBets() {
    this.soccerBetService.getSoccerBets(this.event_id).subscribe((data: any) => {
      //console.log(data);
      this.soccer_bets = data;
      //console.log(this.soccer_bets);
    });
  }

  getMarketType(type:string){
    let res = "";
    console.log('type',type);
    switch(type.replace(/\s+/g, '').toLowerCase()){
      case "Match Odds":
        case "Match Odds".replace(/\s+/g, '').toLowerCase():
        res="match_odd";
      break;
      case "Over/Under 0.5 Goals":
      case "Over/Under 0.5 Goals".replace(/\s+/g, '').toLowerCase():
        res="soccer_under_zero";
      break;
      case "Over/Under 1.5 Goals":
      case "Over/Under 1.5 Goals".replace(/\s+/g, '').toLowerCase():
        res="soccer_under_one";
      break;
      case "Over/Under 2.5 Goals":
      case "Over/Under 2.5 Goals".replace(/\s+/g, '').toLowerCase():
        res="soccer_under_two";
      break;
      case "Over/Under 3.5 Goals":
      case "Over/Under 3.5 Goals".replace(/\s+/g, '').toLowerCase():
        res="soccer_under_three";
      break;
      case "Over/Under 4.5 Goals":
      case "Over/Under 4.5 Goals".replace(/\s+/g, '').toLowerCase():
        res="soccer_under_four";
      break;
      case "Over/Under 5.5 Goals":
      case "Over/Under 5.5 Goals".replace(/\s+/g, '').toLowerCase():
        res="soccer_under_five";
      break;
      // default:
      //   res="match_odd";
    }
    console.log('res-->',res);
    return res;
  }

  getMarket() {
    
    this.marketSubscription = this.soccerOddService.getSoccerOddsByEventId(this.event_id).subscribe((res: any) => {
      if (res.length !== 0 || res != null) {
        this.markets = res;
        this.event_id = this.markets[0].event_id;
        this.inplay = this.markets[0].inplay=='1'?true:false;
        this.market = this.markets.reduce((acc: any, obj1: any) => {
          console.log('obj1',obj1);
          const marketType = this.getMarketType(obj1.market_name);
          const soccer_bets_for_event = this.soccer_bets.filter((bet: any) => bet.event_id === obj1.event_id);
          const soccer_bet = soccer_bets_for_event.find((bet: any) => bet.main_type === marketType);
          const marketEntry = {
            ...obj1,
            exp_amount1: soccer_bet?.exp_amount1 || 0,
            exp_amount2: soccer_bet?.exp_amount2 || 0,
            exp_amount3: soccer_bet?.exp_amount3 || 0,
            'marketType': marketType
          };
      
          if (marketType === "match_odd") {
            console.log("in");
            acc[marketType] = marketEntry;
            // acc[marketType].push(marketEntry);
            // console.log('match entry',marketEntry);
          } else {
            acc['under_over'] = acc['under_over'] || [];
            acc['under_over'].push(marketEntry);
          }
          // acc.under_over.sort((a:any, b:any) => {
          //   if (a.market_name < b.market_name) return -1;
          //   if (a.market_name > b.market_name) return 1;
          //   return 0;
          // });
          
          console.log('acc',acc);
          return acc;
        }, {});
        console.log('market',this.market);
        const firstMarketEntry:any = Object.values(this.market).flat().find(entry => entry);
        if (firstMarketEntry) {
            this.event_name = firstMarketEntry.event_name;
            this.competition_name = firstMarketEntry.competition_name;
            this.event_time = firstMarketEntry.start_time;
            console.log('eventtime',this.event_time)
        }
      }
      // this.urlSafe = this.sanitizer.bypassSecurityTrustResourceUrl(this.market[0].link);
    });
  }

  config: MatDialogConfig = {
    disableClose: false,
    hasBackdrop: true,
    backdropClass: 'test',
    width: '90%',
    height: '50%',
    panelClass: 'makeItMiddle', //Class Name that can be defined in styles.css as follows:
  };

  openDialog(type: any, market_id:any, data: any, price: any, size: any, runner_name: string, index: number = 0, min?: number, max?: number) {
    const config = {
      disableClose: true,
      autoFocus: false,
      maxHeight: '100vh',
      maxWidth: '100vh',
      width: '100vh',
      position: { top: '50px' },
      data: {
        g_type: 'soccer',
        m_type: type,
        type: data,
        user_id: localStorage.getItem('user_id'),
        event_id: this.event_id,
        runner_name: runner_name,
        value: {'price': price, 'size': size},
        market_id: market_id,
        index: index,
        market_name: this.market['match_odd'].event_name,
        enable_draw:true,
        ...(min !== undefined && max !== undefined ? { min, max } : {}),
      }
    };

    if(!this.isMobile){
      this.betSlipService.setSharedData(config.data);
      this.betSlipService.callParentFunction();
    }else{
      // let firstSpan = this.btn.nativeElement;
      const dialogRef = this.dialog.open(BetslipComponent, config);

      setTimeout(() => {
        this.toastr.info('please select bet again');
        dialogRef.close();
      }, 10000);

      dialogRef.afterClosed().subscribe(result => {
        console.log(`Dialog result: ${result}`);
      });
    }
  }

  selectTab(index: number): void {
    this.selectedTabIndex = index;
  }

  ngOnDestroy(): void {
    clearInterval(this.myInterval);
    this.marketSubscription.unsubscribe();
    // this.scoreSubscription.unsubscribe();
  }

  toggleShowTv() {
    this.show_tv = !this.show_tv;
  }

  checkIsMobile() {
    this.isMobile = window.innerWidth <= 768;
  }
}
